export const scrollIntoView = (id: string): void => {
    const element = document.getElementById(id);

    if (element) {
        const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-total-height'));
        const offset = element.getBoundingClientRect().top + window.scrollY - headerHeight;

        window.scrollTo({
            top: offset,
            behavior: 'smooth',
        });
    }
};
